function isLegacyClassroomDisabled () {
  return true
}

module.exports = { isLegacyClassroomDisabled }
